import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Form } from "react-bootstrap";
import { Button, Checkbox, Table, Space } from 'antd';
//import moment from "moment";

import authHeader from "../services/auth-header";
import AuthService from "../services/auth.service";
import _db from "../services/data-service";

import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';

import './Dashboard.css';

//const SERVICE = "Service"; 
//const PTI_FUEL = "PTI / Fuel";
//const PTI_NOT_DONE = "NOT DONE";
//const PTI_STATE_FAILED = "FAILED";
//const PTI_STATE_PASSED = "PASSED";

//const USER_CLASS_SUPER = "SUPER"; 
//const USER_CLASS_ADMIN = "ADMIN";

//const monthFormat = 'MMM YYYY';

async function getPutBackItems() {
    let url = "/api/getPutBackItems";
    const { data: response } = await _db.get(url, { headers: authHeader() });
    return response
}

let putBackItems = {};
getPutBackItems().then((items) => {
    for (const { value, description } of items) {
        putBackItems[value] = description;
    }

    //const dictionnaire = items.reduce((acc, { value, description }) => {
    //    acc[value] = description;
    //    return acc;
    //}, {});
});


const Dashboard = () => {
    //const locat = useLocation();
    //const sTerminal = locat.state?.sel;
    //const sLocation = locat.state?.lc;

    const { Column } = Table;

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let sTerminal = params.get('t');
    let sLocation = params.get('l');
    
    const user = AuthService.getCurrentUser();   
    const [onlineUser, setOnlineUser] = useState({ userCode: '', userName: '', password: '', lines: '', class: '', remote: '', terminal: '', allowPti: false, allowPtiApproval: false });
    const [terminals, setTerminals] = useState([]);
    const [location, setLocation] = useState(sLocation);
    //const [putBackItems, setPutBackItems] = useState([]); 

    const [isLoading, setIsLoading] = useState(false);
    const [onLoad, setOnLoad] = useState(true);
    const [data, setData] = useState([]);

    //const [container, setContainer] = useState('');
    //const userCanApprove = (onlineUser.class === USER_CLASS_ADMIN || onlineUser.class === USER_CLASS_SUPER);

    const [selected, setSelected] = useState(sTerminal);
    const handleChange = e => {
        setSelected(e.target.value);
    }

    async function populateTerminals() {
        const { data: response } = await _db.getTerminals();
        setTerminals(response);
    }

    //const getUserTerminal = async () => {
    //    const { data: response } = await _db.getCurrentUserTerminal();
    //    if (sTerminal) {
    //        setSelected(sTerminal);
    //    } else
    //    if (response !== '') {
    //        setSelected(response);
    //    }
    //}

    const getUserData = async () => {
        const { data: userData } = await _db.getCurrentUserData();
        setOnlineUser({ ...userData });

        if (sTerminal) {
            setSelected(sTerminal);
        } else
            if (userData.terminal !== '') {
                setSelected(userData.terminal);
            }
    }

    //const rowSelection = {
    //    onChange: (selectedRowKeys, selectedRows) => {
    //        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    //    },
    //    onSelect: (record, selected, selectedRows) => {
    //        console.log(record, selected, selectedRows);
    //    },
    //    onSelectAll: (selected, selectedRows, changeRows) => {
    //        console.log(selected, selectedRows, changeRows);
    //    },
    //};

    //Load on startup
    useEffect(() => {
        populateTerminals();
        //getUserTerminal();
        getUserData();
        //getPutBackItems();
    }, []);

    useEffect(() => {
        if (sLocation) getData();
    }, []);

    const getData = async () => {
        try {
            setIsLoading(true);
            setOnLoad(false);

            let URL = "/api/dashboardGetGensets";
            //console.log('Dashboard Get Genset', authHeader(), selected, location);
            const response = await _db.get(URL, { headers: authHeader(), params: { terminal: selected, location: location } });
            setData(response.data);

            console.log("data", response.data)
            
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };

    /* SEARCH */
    const locationChangeHandler = (e) => {
        setLocation(e.target.value.toString().toUpperCase());
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && e.target.value.length > 0) {
            getData()
        }
    }
    /* END SEARCH */

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const handleRowSelect = (e, equip, birthDate, lifeNum, numPhases, fuel, sLine, ptiDone, ptiState) => {
        //console.log(`checked = ${e.target.checked}`);
        const selectedRows = [...selectedRowKeys];
        const index = selectedRows.findIndex(w => w.container === equip);
        const row = {
            "container": equip,
            "birthDate": birthDate,
            "lifeNum": lifeNum,
            "numPhases": numPhases,
            "mecanic": user.userName,
            "fuel": fuel,
            "shippingLine": sLine,
            "terminalCode": selected,
            "ptiDone": ptiDone,
            "ptiState": ptiState
        };

        if (e.target.checked) {         
            if (index < 0) {
                selectedRows.push(row);
            }
        }
        else {
            selectedRows.splice(index, 1);
        }

        setSelectedRowKeys(selectedRows);
    };
    /* END SELECT ROW TO APPROVE */

    const handleApprove = async () => {
        const url = "api/dashboardapprove";
        const oData = {
             "tGInspsJson": JSON.stringify(selectedRowKeys)
        };

        await _db.post(url, oData, { headers: authHeader() })
                 .then((reponse) => {                    
                    getData(); // refresh the page
                    _db.openNotificationWithIcon('success', 'Approved succesfully!');
                 })
                 .catch((error) => {
                    //console.log(error)
                    _db.openNotificationWithIcon('error', error)
                 })
    };

    return (
        <>            
            <div className="border border-5 border-secondary overflow bg-secondary" style={{ borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>

                <div className="container bg-secondary">
                    <div className="row">
                        <div className="col-md-4 my-2">
                            <span className="fs-4 fw-bold text-white">DASHBOARD</span>
                        </div>
                        <div className="col-md-3 my-2 offset-md-2">
                            <div className="row">
                                <div className="fs-6 fw-bold d-flex justify-content-end">
                                    <Form.Label className="me-2 mt-1 text-white">Terminal</Form.Label>
                                    <Form.Select value={selected || ''} inline="true" className="fs-7 terminal-select" size="sm" onChange={(e) => handleChange(e)}>
                                        {/* <option value="ALL">All Terminals</option> */}
                                        {terminals.map((terminal) => (<option key={terminal.terminalCode} value={terminal.terminalCode}>{terminal.terminalCode}</option>))}
                                    </Form.Select>
                                </div>
                            </div>
                        </div>  
                        <div className="col-md-2 my-2 offset-md-1">
                            <div className="row">
                                <div className="fs-6 fw-bold d-flex justify-content-end">
                                    <Form.Label className="me-2 mt-1 text-white">Location</Form.Label>
                                    <Form.Control
                                        className="fs-7"
                                        maxLength={6}
                                        size="sm"
                                        type="text"
                                        name="location"
                                        value={location || ''}
                                        onChange={locationChangeHandler}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container bg-white">
                    <div className="row">
                        <div className="col-md-3 col-sm-12 my-2 pt-3">
                            <span className="fw-bold">GENSET PTI</span> - {user && user.userName}/{new Date().toDateString()}
                        </div>
                        <div className="col-md-5 col-sm-12 my-2">
                            <Button type="primary" className="rounded" disabled={!location} onClick={getData}>REFRESH</Button>
                            <Link to={{ pathname: "/pti/list", search: `?t=${selected}&l=${location}` }}>
                                <Button type="primary" className="rounded ms-2 mt-2" disabled={!location}>PTI MODE</Button>
                            </Link> 
                            <Link to={{ pathname: "/pti/fuel", search: `?t=${selected}&l=${location}`, /*state: { sel: selected, lc: location }*/ }}>
                                <Button type="primary" className="rounded ms-2 mt-2" disabled={!location}>FUEL MODE</Button>
                            </Link>                            
                        </div>
                        <div className="col-md-1 col-sm-6 my-2 text-md-center">
                        </div>

                        <div className="col-md-3 col-sm-6 my-2 text-md-end">
                            <Button type="primary" className="rounded" disabled={!(selectedRowKeys.length)} onClick={handleApprove}>APPROVE</Button>
                            <Button type="primary" className="rounded ms-2 mt-2">EXIT</Button>
                        </div>
                    </div>
                </div>

            </div>
            <div className="content">
                {
                    !isLoading &&
                    <Table
                        //columns={columns}
                        className="fw-bold border border-5 border-secondary table-overflow-visible"
                        dataSource={data}
                        pagination={false}
                        //bordered
                        //rowClassName={() => 'border-row'}
                        scroll={{ x: 'max-content' }}
                        //scroll={{ x: 'max-content',}}
                        //locale={{
                        //    emptyText: !onLoad ? <span style={{ color: 'red', fontWeight: 'bold' }}>No data found !</span> : '',
                        //}}
                        //rowSelection={{ ...rowSelection, }}
                    >
                            <Column
                                className="fw-bold text-center border-secondary"
                                //title="APPROVE"
                                //dataIndex="approve"
                                key="approve"
                                fixed="left"
                                render={(text, record) => (
                                    <Checkbox
                                        onChange={(e) => handleRowSelect(e, record.equipNum, record.birthDate, record.lifeNum, record.numPhases, record.fuel, record.line, record.ptiDone, record.ptiState)}
                                        disabled={!onlineUser.allowPtiApproval || ((!(record.ptiState === 'PASSED' || record.ptiState === 'FAILED')) && !(record.ptiState == null && record.fuel != null))}
                                    />
                                 )}    
                            />
                            <Column
                                className="fw-bold text-center border-secondary"
                                title="STATUS"
                                dataIndex="eqStatus"
                                key="eqStatus"
                                fixed="left"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary"
                                title="LOC"
                                dataIndex="location"
                                key="location"
                                fixed="left"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary"
                                title="GENSET NO."
                                dataIndex="equipNum"
                                key="equipNum"
                                fixed="left"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary"
                                title="SHIP. LINE"
                                dataIndex="line"
                                key='line'
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary text-nowrap"
                                title="MODEL"
                                dataIndex="model"
                                key="model"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary text-nowrap"
                                title="SERIAL"
                                dataIndex="serial"
                                key="serial"
                                //render={(text) => <span>{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary"
                                title="PUT BACK"
                                //dataIndex="putBack"
                                key="putBack"
                                width={60}
                                render={(_, item) => (<Space> {putBackItems[item.putBack]}</Space>)}
                                //render={(text) => <span>{putBackItems[text]}</span>
                            />
                            <Column
                                className="fw-bold text-center border-secondary border-y-2"
                                title="PTI TYPE"
                                key="ptiType"
                                render={(_, item) => (
                                    <Space size="middle">
                                        {item.ptiType ? item.ptiType : item.inPtiType}
                                    </Space>
                                )}
                            />
                            <Column
                                className="fw-bold text-start border-secondary"
                                width={80}
                                title="COMMENTS"
                                dataIndex="ptiComment"
                                key="ptiComment"
                                //render={(text) => <span>{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary text-nowrap"
                                title="PTI DONE"
                                dataIndex="ptiState"
                                key="ptiState"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="fw-bold text-center border-secondary text-nowrap"
                                title="FUEL"
                                dataIndex="fuel"
                                key="fuel"
                                //render={(text) => <span>{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary"
                                title="GPS HEALTH"
                                //dataIndex="inGps"
                                key="inGps"
                                render={(text) => <span>{text === 'T' ? 'YES' : 'NO'}</span>}
                                //render={(_, item) => (
                                //    <Space size="middle">
                                //        {item.inGps === "T" ? "YES" : "NO"}
                                //    </Space>
                                //)}
                            />
                            <Column
                                className="text-center fw-bold border-secondary"
                                title="INSTALL GPS"
                                //dataIndex="inGpsInstl"
                                key="inGpsInstl"
                                render={(_, item) => (
                                    <Space size="middle">
                                        {item.inGpsInstl === "T" ? "YES" : "NO"}
                                    </Space>
                                )}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="CURRENT HOURS"
                                dataIndex="hours"
                                key="hours"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="LAST PTI HOURS"
                                dataIndex="lastPtiHours"
                                key="lastPtiHours"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="LAST PM HOURS"
                                dataIndex="lastPmHours"
                                key="lastPmHours"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="OIL"
                                dataIndex="oil"
                                key="oil"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="PRESTONE"
                                dataIndex="prestone"
                                key="prestone"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="PLATE"
                                dataIndex="p917228Sub"
                                key="p917228Sub"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="SHORT BOLT"
                                dataIndex="b079719"
                                key="b079719"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            <Column
                                className="text-center fw-bold border-secondary text-nowrap"
                                title="LONG BOLT"
                                dataIndex="b079720"
                                key="b079720"
                                //render={(text) => <span className="fs-6 fw-bold text-center">{text}</span>}
                            />
                            {/*<Column title="LAST PTI DATE" key="lastPtiDate"*/}
                            {/*    render={(_, item) => (*/}
                            {/*        <Space size="middle">*/}
                            {/*            {isNaN(Date.parse(item.lastPtiDate)) ? '' : moment(item.lastPtiDate).format(monthFormat)}*/}
                            {/*        </Space>*/}
                            {/*    )}*/}
                            {/*/>*/}
                    </Table>
                }
                {
                    isLoading &&
                    <div className="border border-5 border-secondary overflow" style={{ borderColor: 'gray', padding: '0px', width: '100%', textAlign: 'center', fontSize: '32px' }}>
                        <i className="fa fa-spinner fa-spin" style={{ paddingTop: '10px' }}></i>
                    </div>
                }

            </div>            
        </>  
    );
};

export default Dashboard